import { useCallback, useEffect, FC } from 'react';

import { OpenChatikParams } from '@hh.ru/chatik-integration';
import Loading, { LoadingScale } from 'bloko/blocks/loading';

import ContainerForMicroFrontend from 'src/components/CodeInjector/ContainerForMicroFrontend';

import styles from './chatikSpoiler.less';

interface ChatikSpoilerProps {
    chatId: number;
    openChatik?: (params: OpenChatikParams) => void;
}

const ChatikSpoiler: FC<ChatikSpoilerProps> = ({ chatId, openChatik }) => {
    const handleChatOpening = useCallback(
        (ev: CustomEvent<{ id: number }>) => {
            const id = ev.detail?.id;

            if (id === chatId) {
                openChatik?.({
                    chatId,
                    view: 'compact',
                    hhtmFromLabel: 'employer_vacancy_responses_spoiler',
                });
            }
        },
        [chatId, openChatik]
    );

    useEffect(() => {
        window.addEventListener('Chatik-OpenChat', handleChatOpening as EventListener);
        return () => window.removeEventListener('Chatik-OpenChat', handleChatOpening as EventListener);
    }, [handleChatOpening]);

    return (
        <div className={styles.chatikSpoiler}>
            <span className={styles.loader}>
                <Loading scale={LoadingScale.Medium} />
            </span>
            <ContainerForMicroFrontend place={`spoiler-chat-${chatId}`} preloadContent={null} />
        </div>
    );
};

export default ChatikSpoiler;
